import { Calendar as CalendarIcon, Clock, MapPin } from 'lucide-react';
import { Calendar } from '../components/ui/calendar';
import { useState } from 'react';

export default function MentorshipCalendar() {
  const [date, setDate] = useState(new Date());

  const upcomingEvents = [
    {
      title: 'Q1 - Real Estate & Global Markets Immersion',
      date: 'January 2026',
      time: 'TBA',
      location: 'Virtual (Zoom)',
    },
    {
      title: 'Q2 - International Entrepreneurship Workshop',
      date: 'April 2026',
      time: 'TBA',
      location: 'Virtual (Zoom)',
    },
    {
      title: 'Q3 - Business Strategy & Pitch Development',
      date: 'July 2026',
      time: 'TBA',
      location: 'Virtual (Zoom)',
    },
    {
      title: 'Q4 - Financial Literacy & Year-End Review',
      date: 'October 2026',
      time: 'TBA',
      location: 'Virtual (Zoom)',
    },
  ];

  return (
    <div className="min-h-screen bg-cream" data-testid="mentorship-calendar-page">
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.pexels.com/photos/5306434/pexels-photo-5306434.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="African American professional mentoring a student"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-cabernet/70"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-8 py-16 sm:py-20">
          <p className="text-sm uppercase tracking-[0.2em] font-accent font-bold text-brass mb-3">
            Mentorship Program
          </p>
          <h1 className="text-4xl sm:text-5xl font-heading font-medium text-cream tracking-tight leading-none mb-4">
            Entrepreneurship Mentorship
          </h1>
          <p className="font-body text-base text-cream/80 max-w-2xl leading-relaxed">
            Connect with industry professionals through our structured mentorship meetings. 
            Sessions cover real estate, international business, and entrepreneurship development.
          </p>
        </div>
      </section>

      {/* Calendar Section */}
      <section className="py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="grid lg:grid-cols-3 gap-8">
            {/* Shadcn Calendar Widget */}
            <div className="lg:col-span-1">
              <div className="bg-card-surface rounded-lg border border-brass/20 shadow-sm p-6" data-testid="calendar-widget">
                <h2 className="text-xl font-heading font-medium text-cabernet mb-4">Calendar</h2>
                <Calendar
                  mode="single"
                  selected={date}
                  onSelect={setDate}
                  className="rounded-md"
                />
              </div>
            </div>

            {/* Google Calendar Embed */}
            <div className="lg:col-span-2">
              <div className="bg-card-surface rounded-lg border border-brass/20 shadow-sm p-6" data-testid="google-calendar-embed">
                <h2 className="text-xl font-heading font-medium text-cabernet mb-4">
                  Meeting Schedule
                </h2>
                <div className="rounded-lg overflow-hidden border border-brass/30 shadow-md">
                  <iframe
                    src="https://calendar.google.com/calendar/embed?src=en.usa%23holiday%40group.v.calendar.google.com&ctz=America%2FNew_York&showTitle=0&showNav=1&showDate=1&showPrint=0&showTabs=1&showCalendars=0&showTz=1&mode=MONTH"
                    style={{ border: 0 }}
                    width="100%"
                    height="500"
                    frameBorder="0"
                    scrolling="no"
                    title="Mentorship Meeting Calendar"
                    data-testid="google-calendar-iframe"
                  ></iframe>
                </div>
                <p className="font-body text-xs text-ink/50 mt-3">
                  Contact your mentor coordinator to add meetings to the shared calendar.
                </p>
              </div>
            </div>
          </div>

          {/* Upcoming Events */}
          <div className="mt-12" data-testid="upcoming-events">
            <h2 className="text-2xl sm:text-3xl font-heading font-medium text-cabernet mb-6">
              Upcoming Mentorship Sessions
            </h2>
            <div className="grid sm:grid-cols-2 gap-4">
              {upcomingEvents.map((event) => (
                <div
                  key={event.title}
                  className="bg-card-surface rounded-lg border border-brass/20 shadow-sm p-6"
                  data-testid={`event-card-${event.title.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <h3 className="font-heading text-lg font-medium text-cabernet mb-3">
                    {event.title}
                  </h3>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-sm text-ink/70">
                      <CalendarIcon className="w-4 h-4 text-brass" />
                      <span className="font-body">{event.date}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-ink/70">
                      <Clock className="w-4 h-4 text-brass" />
                      <span className="font-body">{event.time}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-ink/70">
                      <MapPin className="w-4 h-4 text-brass" />
                      <span className="font-body">{event.location}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
